import gridService from "@/services/grid";

export const state = {
  loading: false,
  tableHeaders: {},
  adminPreferenceId: null,
  selectedRows: [],
  filterValues: {},
};

export const actions = {
  onTableHeader({ commit, dispatch }, params) {
    commit("setLoadong", true);
    return new Promise((resolve, reject) => {
      gridService
        .getTableHeaders(params)
        .then((data) => {
          data.data && data.data.length > 0
            ? (resolve(data),
              commit("setTableHeaders", JSON.parse(data.data[0].table_head)),
              commit("setAdminPreferenceId", data.data[0].id),
              commit("setLoadong", false))
            : dispatch("createTableHeaders", params);
        })
        .catch((err) => {
          reject(err);
          this._vm.$toast.error(err.data.message);
          commit("setLoadong", false);
        });
    });
  },
  resetTableHeaders({ commit }) {
    commit("setTableHeaders", {});
  },
  createTableHeaders({ commit }, params) {
    commit("setLoadong", true);
    return new Promise((resolve, reject) => {
      gridService
        .createTableHeaders(params)
        .then((data) => {
          resolve(data);
          commit("setLoadong", false);
        })
        .catch((err) => {
          reject(err);
          this._vm.$toast.error(err.data.message);
          commit("setLoadong", false);
        });
    });
  },
  updateTableHeaders({ commit, dispatch }, params) {
    commit("setLoadong", true);
    return new Promise((resolve, reject) => {
      gridService
        .updateTableHeaders(params)
        .then((data) => {
          resolve(data);
          dispatch("onTableHeader", params);
          commit("setLoadong", false);
          this._vm.$toast.success(data.message);
        })
        .catch((err) => {
          reject(err);
          dispatch("notification/error", err, { root: true });
          commit("setLoadong", false);
          this._vm.$toast.error(err.data.message);
        });
    });
  },
  onSelectedRows({ commit }, payload) {
    commit("setSelectedRows", payload);
  },
  resetSelectedRows({ commit }) {
    commit("setSelectedRows", []);
  },
  // filtration
  onSetFilterValue({ commit }, payload) {
    commit("setFilterValue", payload);
  },
  onClearFilterValue({ commit }, key) {
    commit("clearFilterValue", key);
  },
  resetFilterValues({ commit }) {
    commit("resetFilterValues");
  },
};

export const mutations = {
  setLoadong(state, payload) {
    state.loading = payload;
  },
  setTableHeaders(state, payload) {
    state.tableHeaders = payload;
  },
  setSelectedRows(state, payload) {
    state.selectedRows = payload;
  },
  setAdminPreferenceId(state, payload) {
    state.adminPreferenceId = payload;
  },
  // filtration
  setFilterValue(state, payload) {
   Object.keys(payload)[0];
   Object.values(payload)[0];
   state.filterValues[Object.keys(payload)[0]]=Object.values(payload)[0];
  },
  clearFilterValue(state, key) {
    delete state.filterValues[key];
  },
  resetFilterValues(state) {
    state.filterValues = {};
  },
};

export const getters = {
  getTableHeaders(state) {
    return state.tableHeaders;
  },
  getSelectedRows(state) {
    return state.selectedRows;
  },
  getAdminPreferenceId(state) {
    return state.adminPreferenceId;
  },
  getLoading(state) {
    return state.loading;
  },
  getFilterValues(state) {
    return state.filterValues;
  },
};
